<template>
  <div class="row d-flex align-content-center">
    <div class="col-12 d-flex align-items-center justify-content-center vh-100">
      <div
        class="innerpadding-30 w-600"
        style="background-color: #fd7624; border-radius: 30px"
      >
        <h2 class="purple-text onboard">TAS Network Check</h2>

        <section>
          <div style="padding: 20px">
            <div>
              Checking browser:
              <span v-if="canRunJavascript">{{ canRunJavascript }}</span
              ><span v-else class="button-loading-spinner"></span>
            </div>
            <div>
              Connect to TAS data server:
              <span v-if="canReachServer">{{ canReachServer }}</span
              ><span v-else class="button-loading-spinner"></span>
            </div>
            <div>
              Connect to TAS asset server:
              <span v-if="canReachAssetsServer">{{ canReachAssetsServer }}</span
              ><span v-else class="button-loading-spinner"></span>
            </div>
            <div>
              Write to TAS realtime database:
              <span v-if="canWriteToFirestore">{{ canWriteToFirestore }}</span
              ><span v-else class="button-loading-spinner"></span>
            </div>
            <div>
              Read from TAS realtime database:
              <span v-if="canReadFromFirestore">{{ canReadFromFirestore }}</span
              ><span v-else class="button-loading-spinner"></span>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import { db } from '../store/db.js'
import { gameAssetsMixin } from '../mixins/gameAssetsMixin'

export default {
  mixins: [gameAssetsMixin],
  components: {},
  props: [],

  data: () => ({
    code: '',
    message: '',
    valid: false,
    canRunJavascript: undefined,
    canReachServer: undefined,
    canReachAssetsServer: undefined,
    canWriteToFirestore: undefined,
    testTeamID: undefined
  }),
  created() {
    this.canRunJavascript = 'SUCCESS'

    this.checkTestGameCode()
    this.checkAssetServerAccess()
    this.checkDatabaseWrite()
  },
  watch: {
    canWriteToFirestore(newValue, oldValue) {
      console.log(
        `canWriteToFirestore changing from ${oldValue} to ${newValue}`
      )

      if (newValue === 'FAILED') {
        this.canReadFromFirestore = 'FAILED'
      } else if (newValue === 'SUCCESS') {
        this.checkDatabaseRead()
      }
    }
  },
  computed: {
    ...mapState({
      game: state => state.game
    }),
    gameData() {
      return this.game.game?.gameData
    },
    canReadFromFirestore() {
      if (this.game.teamDataError) {
        return 'FAILED'
      }

      if (this.gameData === undefined) {
        return undefined
      }

      return 'SUCCESS'
    }
  },
  methods: {
    ...mapActions('game', ['fetchGame', 'fetchTeamData']),
    checkAssetServerAccess() {
      const url = this.resolveGameAssetURL('murder-mystery', 'logo.svg')

      axios
        .get(url)
        .then(() => {
          this.canReachAssetsServer = 'SUCCESS'
        })
        .catch(error => {
          console.log('There was a problem loading the asset: ' + error.message)

          this.canReachAssetsServer = 'FAILED'
        })
    },
    checkTestGameCode() {
      this.fetchGame({ code: 'TEST_GAME' })
        .then(response => {
          console.log('🦟 response.status: ' + response.status)

          console.log('game code is valid')

          this.canReachServer = 'SUCCESS'
        })
        .catch(error => {
          console.log('There was a problem loading the game: ' + error.message)

          this.canReachServer = 'FAILED'
        })
    },
    checkDatabaseWrite() {
      db.collection(`gameCodes/TEST_GAME/teamData`)
        .add({
          ping: 'ping'
        })
        .then(docRef => {
          console.log(`Success adding team: ${docRef.id}`)
          this.testTeamID = docRef.id

          this.canWriteToFirestore = 'SUCCESS'
        })
        .catch(error => {
          console.log(`Error adding ping: ${error}`)
          this.canWriteToFirestore = 'FAILED'
        })
    },
    checkDatabaseRead() {
      this.fetchTeamData({ code: 'TEST_GAME', teamId: this.testTeamID })
    }
  }
}
</script>
<style></style>
